import { connect } from 'react-redux'
import ActionBar from '../../../components/Sections/Imi/ActionBar'
import { setYears, setMonth, loadDates, searchImisByWords } from '../../../actions/imi';

const mapStateToProps = (state, ownProps) => {
  return {
 		dates: state.imi.dates,
    year: state.imi.year,
    month: state.imi.month
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    onChangeYear: value => dispatch(setYears(value)),
    onChangeMonth: value => dispatch(setMonth(value)),
    loadDates: () => dispatch(loadDates()),
    searchImisByWords: value => dispatch(searchImisByWords(value)),
    resetFilters: () => {
      dispatch(setYears()),
      dispatch(setMonth())
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ActionBar)


// WEBPACK FOOTER //
// ./src/containers/Sections/Imi/actionBar.js